<template>
    <v-card class="fondo-presentacion">
        <v-card-title>

        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="12" md="2">
                    <center>
                        <v-avatar size="100" style="opacity: .8" class="mr-2 bouncing">
                            <v-img
                                class="elevation-6"
                                alt="Claudia"
                                src="img/claudia.png"
                            ></v-img>
                        </v-avatar>
                    </center>
                </v-col>
                <v-col cols="12" sm="12" md="10">
                    <span v-html="bienvenida"></span>
                </v-col>
            </v-row>
        </v-card-text>
        <!-- <center>
            <v-img width="25%" style="opacity: .4" src="img/claudia.png"></v-img>  
        </center> -->
    </v-card>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        name: "Bienvenida",
        components: {
            
        },
        data() {
            return {
                textoBienvenida: '',
                bienvenida: '',
                posicion: 0,
                velocidadEscritura: 15,
                writingHTML: false
            }
        },
        mounted(){
            this.textoBienvenida = '¡Hola, '+this.authUser.name+'! Me llamo <span class="ai">Claudia</span><span class="mdi mdi-creation ai"></span> y seré tu asistente virtual.<br>Estoy basada en GPT-4 turbo y, aunque estoy en fase de pruebas, haré todo lo posible por ayudarte.<br>A continuación te he preparado una selección de informes que creo que pueden serte útiles. Si necesitas uno nuevo, ¡solo tienes que pedírmelo!',
            this.typingEffect();
        },
        methods: {
            typingEffect(){
                if(this.posicion < this.textoBienvenida.length){
                    if(this.textoBienvenida.charAt(this.posicion) === '<'){
                        this.writingHTML = true
                    }
                    if(this.textoBienvenida.charAt(this.posicion) === '>'){
                        this.writingHTML = false
                    }
                    if(!this.writingHTML){
                        this.bienvenida += this.textoBienvenida.charAt(this.posicion)
                        this.posicion++
                        setTimeout(this.typingEffect, this.velocidadEscritura)
                    }else{
                        this.bienvenida += this.textoBienvenida.charAt(this.posicion)
                        this.posicion++
                        this.typingEffect()
                    }
                }
            }
        },
        computed: {
            ...mapState("login", ["authUser"]),
        }
    }
</script>
<style>
    .fondo-presentacion.v-card.v-sheet.theme--light {
        background-color: #009fc31c;
    }
    .ai{
      animation: rainbow 4s linear infinite;
      background-image: linear-gradient(90deg,#00e6e6,#0059ff,#00e6e6,#0059ff);
      background-size: 300% 100%;
      -webkit-background-clip: text !important;
      background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
      font-weight: bolder;
    }
    @keyframes rainbow { 
        0% { background-position: 100% 0%; }
        100% { background-position: 0% 0%; }
    }
    .bouncing {
        animation: bounce 1.5s ease 1;
    }
    @keyframes bounce {
        0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
        40% {transform: translateY(-20px);}
        60% {transform: translateY(-10px);}
    }
</style>
